import Typeahead from './dom';
export default Typeahead;
